import { rem } from "polished";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/use-color";

export const Wrapper = styled.div`
  color: #fff;
  background-color: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};
  position: relative;
`;

export const CTAButtonWrapper = withViewportStyle("div")`
  padding: 0 ${rem(24)} 0;
  white-space: nowrap;

  .button-primitive {
    font-weight: 600;
    font-size: ${rem(15)};
    line-height: ${rem(28)};
    display: block;
    padding: ${rem(6)} ${rem(40)};
    background-color: transparent;
    color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
    border: ${rem(2)} solid
      ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
    border-radius: ${rem(200)};

    ${(props) => props.$viewport.mobile`
      font-size: ${rem(12)};
      padding-top: 0;
      padding-bottom: 0;
    `}
  }
`;
